var map = {
	"./allcamsex.png": 56,
	"./cams.png": 57,
	"./flirt4free.png": 58,
	"./hdcamchats.png": 59,
	"./imlive.png": 60,
	"./livecamguru.png": 61,
	"./myfreecams.png": 62,
	"./sexier.png": 63,
	"./stripchat.png": 64,
	"./xlovecam.png": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;